import React from "react";

/* Atoms */
import { Icon } from 'js/components/atoms';

/* Symbols */
import toolTip from 'symbols/tooltip.svg';

export default function CardLabel({ style, labelTitle, onClick }) {
    return (
        <div
            className="card__label card__label--info d-flex align-items-center gap-2 px-2"
            style={style}
        >
            <p className="text-white font-weight-extra-bold mb-0">{labelTitle}</p>
            <div
                className="btn--tooltip btn--tooltip--pointer d-flex align-items-center"
                onClick={onClick}
            >
                <Icon
                    theme="white"
                    size={20}
                    url={toolTip}
                />
            </div>
        </div>
    )
}
